import React from "react";
import { ImageInput } from "@raketa-cms/raketa-image-picker";
import MediaManager from "../MediaManager";

export default ({ name, image }) => {
  const mediaManager = new MediaManager("/");

  return <ImageInput name={name} image={image} mediaManager={mediaManager} />;
};
